import React from 'react';
import './BadgeEstado.css';

/**
 * BadgeEstado — Componente universal de etiqueta y badge de estado del sistema.
 *
 * Reemplaza los <span> con estilos en línea y colores hardcodeados.
 * Utiliza los tokens de estado (éxito, advertencia, peligro, info, neutro)
 * o los tokens de área/rol (admin, rti, art, recepcion, cobranzas, anses).
 *
 * @param {string} [tono]      exito | advertencia | peligro | info | neutro |
 *                             admin | rti | art | recepcion | cobranzas | anses | primario
 * @param {string} [icono]     Nombre de icono en Bootstrap Icons sin prefijo "bi-"
 * @param {bool}   [dot=false] Muestra un punto coloreado antes del texto
 * @param {bool}   [pill=true] Forma redondeada completa (border-radius: pill)
 * @param {node}   children    Texto del badge
 * @param {string} [className] Clases adicionales
 */
export default function BadgeEstado({
    tono = 'neutro',
    icono,
    dot = false,
    pill = true,
    children,
    className = '',
    ...props
}) {
    const clase = [
        'ds-badge',
        `ds-badge--${tono}`,
        pill ? 'ds-badge--pill' : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <span className={clase} {...props}>
            {dot && <span className="ds-badge__dot" aria-hidden="true" />}
            {icono && <i className={`bi bi-${icono} ds-badge__icono`} aria-hidden="true" />}
            <span className="ds-badge__texto">{children}</span>
        </span>
    );
}
